// 文件上传服务
export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('file', file);
  const resp = await fetch('/api/upload', {
    method: 'POST',
    body: formData,
  });
  if (!resp.ok) throw new Error('图片上传失败');
  const data = await resp.json();
  if (!data.url) throw new Error('服务器未返回图片地址');
  return data.url;
}
